<template>
  <span class="chip-status" :class="'chip-status--' + aparencia.classe">
    <span class="chip-status__dot"></span>
    {{ aparencia.rotulo }}
  </span>
</template>

<script>
/*
 * Estado de uma integração em uma etiqueta só.
 *
 * "Inativa" vence "falha na conexão": uma integração desligada não está com
 * problema, está desligada — mostrar o erro antigo de uma integração que
 * ninguém usa mais só gera alarme falso.
 */
export default {
  name: 'ChipStatusIntegracao',
  props: {
    ativo: {
      type: Boolean,
      default: false,
    },
    statusConexao: {
      type: String,
      default: 'NAO_TESTADA',
    },
  },
  computed: {
    aparencia() {
      if (!this.ativo) {
        return { classe: 'inativa', rotulo: 'Inativa' };
      }

      if (this.statusConexao === 'FALHA') {
        return { classe: 'falha', rotulo: 'Falha na conexão' };
      }

      if (this.statusConexao === 'OK') {
        return { classe: 'ok', rotulo: 'Conectada' };
      }

      return { classe: 'nao-testada', rotulo: 'Ativa' };
    },
  },
};
</script>

<style scoped>
.chip-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.6;
  white-space: nowrap;
}

.chip-status__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
  flex-shrink: 0;
}

.chip-status--ok {
  background: #e7f6ec;
  color: #1c7a44;
}

.chip-status--nao-testada {
  background: #edf8f9;
  color: #17727b;
}

.chip-status--falha {
  background: #fdeceb;
  color: #b42318;
}

.chip-status--inativa {
  background: #f2f4f7;
  color: #667085;
}
</style>
